import { Layout, Page, usePath } from "@fdoh/health-ui-react";
import { useData } from "../../hooks";
import { AdditionalInformationFormInput } from "../Components/AdditionalInformation.types";
import { AdditionalInformationForm } from "../Components/AdditionalInformationForm";
import ApplicationDetailsPage from "../Components/Home/ApplicationDetails";
import { useHistory, useLocation, useParams } from "react-router-dom";

const EditAdditionalInformationPage = () => {
  const { search } = useLocation();
  const searchParams = new URLSearchParams(search);
    const applicationId = JSON.parse(searchParams.get("applicationId") || '{}');
    const inspectionId = JSON.parse(searchParams.get("inspectionId") || '{}');

    const path = usePath();
    const data = useData<AdditionalInformationFormInput>(path.current);
  return data && applicationId ? (
    <Page.Container>
        <ApplicationDetailsPage id={applicationId}></ApplicationDetailsPage>      
      <Page.Body>
        <Layout.Container>
          <AdditionalInformationForm
            id="editAdditionalInformationPage"
            title="Edit Additional Information"
            action="post"
                      applicationInspectionId={data?.applicationInspectionId}
                      applicationId={applicationId}
                      returnPath={`/inspectionDetails/${inspectionId}`}
            values={data}
          />
        </Layout.Container>
      </Page.Body>
    </Page.Container>
  ): <Page.Container>
  <Page.Header preTitle="Private Provider Inspection" title="Welcome" />
  <Page.Body>
      <Layout.Container>
          <div className="row row-dec row-cards">
              <div className="col-lg-12">
               
              </div>
          </div>
      </Layout.Container>
  </Page.Body>
</Page.Container>;
};

export default EditAdditionalInformationPage;